import React from 'react';
import Image from '@moncler/components/experience/EditorialImage';
import '@moncler/scss/components/editorial-module/editorial-module.scss';
import useBreakpoint from '@common/utils/useBreakpoint';
const EditorialModule = (props) => {
    const { title, description, link, linkText } = props;
    const breakpoint = useBreakpoint();
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "editorial-module row" },
            React.createElement("div", { className: "editorial-module_info col-12 col-sm-5 col-md-4 offset-sm-1" },
                React.createElement("div", { className: "editorial-module_title" }, title),
                React.createElement("div", { className: "editorial-module_description primary-s", dangerouslySetInnerHTML: { __html: description.replaceAll('\n', '<br/>') } }),
                link && (React.createElement("div", null,
                    React.createElement("a", { href: link, className: `editorial-module_cta button--tertiary button--arrow-right ${breakpoint >= window.mqObj.md ? 'primary-s-u' : 'primary-xs-u'}` }, linkText)))),
            React.createElement(Image, Object.assign({}, props, { className: "editorial-module_img col-12 col-sm-4 offset-sm-1 offset-md-2" })))));
};
export default EditorialModule;
